/**
 * The DD conclusion vocabulary — pure, so it can be tested without dragging in
 * the Supabase client the hooks beside it need.
 *
 * `dd_conclusion_decision` is now exactly the three terminal stages of the
 * dealflow spine. Everything else that used to be in it was a stage, not an
 * outcome: `undecided` IS the `diligence` stage, `interested` is an earlier
 * one, and a `committed` amount lives in `commitments`.
 */

export type DDDecision = 'invest' | 'pass' | 'monitor';

/**
 * Map the DD UI's decision vocabulary to the `dd_conclusion_decision` enum.
 *
 * An unrecognised decision THROWS. It used to fall back to `undecided`, which
 * is the one answer that must never be given: the enum no longer accepts that
 * value, so the fallback would have concluded a due diligence as something the
 * database rejects — surfacing as an opaque write failure at the last step of
 * the flow instead of at the bad input. `follow`/`watching` are the legacy
 * spellings of `monitor` and still map, so a caller holding an old string is
 * corrected rather than rejected.
 */
export function normalizeDDDecision(decision: string): DDDecision {
  switch (decision) {
    case 'invest':
      return 'invest';
    case 'pass':
      return 'pass';
    case 'follow_up':
    case 'follow':
    case 'watching':
    case 'monitor':
      return 'monitor';
    default:
      throw new Error(`Unknown due-diligence decision: ${decision}`);
  }
}
